import './LibraryItem.scss'
import {useState} from "react";
import {Button, ProgressBar} from "react-bootstrap";
import {Link} from "react-router-dom";
import {AiOutlineClockCircle} from "react-icons/ai";
import {IoSchool} from "react-icons/io5";
import {courseIcon, format_seconds} from "../Tools";
import {PiTarget} from "react-icons/pi";
import {BsArrowRight, BsCheckCircle, BsChevronDown, BsChevronUp, BsCircle} from "react-icons/bs";
import {useTranslation} from "react-i18next";
export default function LibraryItem({ id, category, recommended, currentCat, setCurrentCat }) {
    const { t, i18n } = useTranslation();
    const [openCategories, setOpenCategories] = useState([])
    let className = ['library-item']

    const toggleOpenCategory = (id) => {
        const open = [...openCategories]
        const idx = open.indexOf(id)
        if(idx !== -1)
            open.splice(idx, 1)
        else
            open.push(id)

        setOpenCategories([...open])
    }
    const isOpenCategory = (id) => {
        return openCategories.indexOf(id) !== -1
    }
    const openCategory = (selected_topic) => {
        category.selected_topic = selected_topic === null ? -1 : selected_topic;
        if(selected_topic === -2 && category.topics_completed) {
            category.selected_topic = -1;
        }
        else if(category.selected_topic !== -1) {
            category.topics_completed = 0;
        }

        //console.log(category);
        setCurrentCat(category)
        //
        // if(!category.completed)
        //     setCurrentCat(category)
        // else
        //     setExpanded(!expanded)
    }

    if(isOpenCategory(category.ID))
        className.push('expanded')

    if(category.completed)
        className.push('completed')
    else if(category.topics_completed && category.video_watched && category.questions.length > 0)
        className.push('finalize')

    if(recommended)
        className.push('current')
    else if(!category.completed && !recommended)
        className.push('locked')

    var activeTopic = null
    var activeTopicIndex = 0
    for(let i = 0; i < category.topics.length; i++) {
        if(!category.topics[i].completed) {
            activeTopic = category.topics[i]
            activeTopicIndex = i
            break
        }
    }
    var progress = 0;
    category.topics.map((topic, idx) => {
        if(topic.completed)
            progress++;
    });
    return <div id={id} className={className.join(' ')}>
        <img src={category.image} alt="" />
        <div className="library-item-info">
            <div className="library-item-header">
                <div className="library-item-title">
                    <h3 className="title" dangerouslySetInnerHTML={{__html: category.name }} />
                    <p className="current-info">
                        {activeTopic ? <span className="text-muted align-items-center d-flex gap-2">
                        <span className="current-title">
                            <span className="d-flex align-items-center">
                                <IoSchool className="me-2 text-info" />
                                <span dangerouslySetInnerHTML={{__html: activeTopic.name }} />
                            </span>
                        </span>
                        <span className="current-duration">
                            <span className="d-flex align-items-center">
                                <AiOutlineClockCircle className="ms-2 me-1" />
                                {format_seconds(activeTopic.duration)}
                            </span>
                        </span>
                    </span> : (className.indexOf('finalize') !== -1 ? <span>
                            <strong className="text-success">{t('course.almostDone')}</strong>
                            <br />
                            <span className="text-muted small">
                                {t('course.almostDoneText')}
                            </span></span>
                            : <strong className="text-success">{t('course.chapterCompleted')}</strong>) }
                    </p>
                </div>
                <div className="library-item-buttons">
                    {className.indexOf('locked') === -1 && className.indexOf('completed') === -1 && className.indexOf('finalize') === -1 &&
                    <Button onClick={() => openCategory(-1) } variant={activeTopicIndex > 0 ? 'info' : 'success'}>{activeTopicIndex > 0 ? t('button.continue') : t('button.start')}</Button>}
                    {className.indexOf('finalize') !== -1 &&
                    <Button onClick={() => openCategory(-2) } variant="success">{t('button.finishChapter')}</Button>}
                </div>
                {className.indexOf('finalize') === -1 && <div className="topic-bars-mobile">
                    <ProgressBar className="library-item-progress" now={(progress / category.topics.length) * 100} label={`${progress}/${category.topics.length}`}
                                 variant={progress < category.topics.length ? 'info' : (category.completed ? 'success' : 'success')} />
                </div>}
                <div className="library-item-mobile-controls">
                    {className.indexOf('locked') === -1 && className.indexOf('completed') === -1 && className.indexOf('finalize') === -1 &&
                    <Button onClick={() => openCategory(-1) } variant="link" className="d-flex align-items-center gap-1"><BsArrowRight /> {activeTopicIndex > 0 ? t('button.continue') : t('button.start')}</Button>}
                    {className.indexOf('finalize') !== -1 &&
                    <Button onClick={() => openCategory(-2) } variant="link" className="d-flex align-items-center gap-1"><BsArrowRight /> {t('button.finishChapter')}</Button>}
                    <span></span>
                    {(activeTopicIndex > 0 || className.indexOf('finalize') !== -1 || className.indexOf('completed') !== -1) && <Button onClick={() => toggleOpenCategory(category.ID) } variant="link" className="d-flex align-items-center gap-1">{t('button.showAll')} {isOpenCategory(category.ID) ? <BsChevronUp /> : <BsChevronDown />}</Button>}
                </div>
            </div>
            {className.indexOf('finalize') === -1 && <div className="topic-bars">
                {category.topics.map((topic, idx) => {
                    let active = activeTopic && activeTopic.ID === topic.ID
                    return <ProgressBar className="library-item-progress" key={'topic-progress-' + idx} now={topic.completed || active ? 100 : 0} label={active ? `${idx + 1}/${category.topics.length}` : ''}
                                        variant={active ? 'info' : (category.completed ? 'success' : 'success')} />
                })}
            </div>}
            {(activeTopicIndex > 0 || className.indexOf('finalize') !== -1 || className.indexOf('completed') !== -1) &&
            <ul className="topic-list">
                {category.topics.map((topic, idx) => {
                    let active = activeTopic && activeTopic.ID === topic.ID
                    return <li key={'topic-list-' + idx} className={(active ? 'current' : '') + ' ' + (topic.completed ? 'completed' : '')}>
                        <Link to="/courses" onClick={topic.completed || active ? () => { openCategory(idx) } : () => {}}>
                            {topic.completed ? <BsCheckCircle /> : (active ? <PiTarget /> : <BsCircle />)}
                            <span dangerouslySetInnerHTML={{__html: topic.name }} />
                            <span className="redo-note">{t('course.redo')}</span>
                        </Link>
                    </li>
                })}
                {category.questions.length > 0 && <li className={(category.completed ? 'completed' : '') + ' ' + (!category.completed && category.topics_completed ? 'current' : '')}>
                    <Link to="/courses" onClick={category.topics_completed ? () => { openCategory(-2) } : () => {}}>
                        {category.completed ? <BsCheckCircle /> : (!category.completed && category.topics_completed ? <PiTarget /> : <BsCircle />)}
                        <span dangerouslySetInnerHTML={{__html: t('course.lastQuiz') }} />
                        <span className="redo-note">{t('course.redo')}</span>
                    </Link>
                </li>}
            </ul>}
        </div>
        <div className="vehicle">
            {courseIcon(category.course_id)}
        </div>
    </div>
}